import { render, staticRenderFns } from "./_base-navbar.vue?vue&type=template&id=5f8b926e&"
import script from "./_base-navbar.vue?vue&type=script&lang=js&"
export * from "./_base-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports